import bProgressBar from './progress-bar'

export default {
  components: { bProgressBar },
  render (h) {
    const t = this
    let childNodes = t.$slots.default
    if (!childNodes) {
      childNodes = h(
        'b-progress-bar',
        {
          props: {
            value: t.value,
            max: t.max,
            precision: t.precision,
            variant: t.variant,
            animated: t.animated,
            striped: t.striped,
            showProgress: t.showProgress,
            showValue: t.showValue
          }
        }
      )
    } else {
      // for (var i = 0; i < childNodes.length; i++) {
      // console.log(childNodes[i])
      // }
    }
    let title = h('b-col', {}, [h('h4', {class: ['text-left,card-title']}, t.title)])
    let progress = h('b-col', {}, [h('h4', { class: ['text-right'] }, Math.round(t.value) + '%')])
    // console.log(progress)
    if (t.showTopProgress) {
      return h('div', {}, [
        h('b-row', {}, [title, progress]),
        h('div', { class: [ 'progress' ], style: t.progressHeight }, [ childNodes ])
      ])
    } else {
      return h('div', {}, [
        h('div', { class: ['progress'], style: t.progressHeight }, [childNodes])
      ])
    }
  },
  props: {
    // These props can be inherited via the child b-progress-bar(s)
    variant: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    showTopProgress: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    animated: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '10px'
    },
    precision: {
      type: Number,
      default: 0
    },
    showProgress: {
      type: Boolean,
      default: false
    },
    showValue: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: 100
    },
    // This prop is not inherited by child b-progress-bar(s)
    value: {
      type: Number,
      default: 0
    }
  },
  computed: {
    progressHeight () {
      return { height: this.height || null }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components-base/components/progress/_progress.js